<template>
  <div class="serviceInventory-container">
    <a-page-header class="page-header" :ghost="false" style="margin-bottom: 16px">
      <template #title>
        <a-space size="middle">
          <a-icon type="cloud" theme="filled" />
          <span>云服务器台账</span>
        </a-space>
      </template>
      <span>云服务器台账包含云服务商、云主机区域等信息。</span>
    </a-page-header>

    <a-card :bordered="false" style="margin-bottom: 16px">
      <list-layout :getTableDataFunc="getTableDataFunc" :columnsAll="columnsAll"
        :columnDefaultSelected="columnDefaultSelected" :exportFunc="exportFunc"
        :toolsList="['setting', 'reload', 'leftTool', 'export', 'search']" :search-type-options="[
          { label: '云服务商', value: 'vendor' },
          { label: '云主机区域', value: 'location' },
          { label: '主机名', value: 'name' },
          { label: '云主机内网 IP', value: 'private_ip' }
        ]" :refresh="refresh">
        <template #leftTool>
          <create-button v-permission="{ action: 'base.inventory.create', effect: 'disabled' }"
            @click="$refs.inputDrawer.show()"></create-button>
        </template>
        <template #rightTool>
          <upload-button v-permission="{ action: 'base.inventory.update' }"
            @click="$refs.uploadModal.show()"></upload-button>
        </template>

        <!-- 自定义列 -->
        <template #service="{ slotProps }">
          <span v-if="slotProps.text">{{ slotProps.text.name }}</span>
          <span v-else>-</span>
        </template>

        <template #addedService="{ slotProps }">
          <span v-if="slotProps.text">{{ slotProps.text.name }}</span>
          <span v-else>-</span>
        </template>

        <template #portMaps="{ slotProps }">
          <div v-if="slotProps.text.length">
            <div v-for="(item, index) in slotProps.text" :key="`${index}-${item.local_port}`" style="margin: 2px 0">
              <div color="skyblue">{{ item.local_port }} -> {{ item.public_ip.ip_address }}:{{ item.map_port }}</div>
            </div>
          </div>
          <span v-else>-</span>
        </template>

        <template #serviceLastLevel="{ slotProps }">
          <a-tag v-if="slotProps.text !== null && slotProps.text !== undefined && slotProps.text !== ''"
            :color="getLevelColor(slotProps.text)">{{ $t(`service_level.${slotProps.text}`) }}</a-tag>
          <span v-else>-</span>
        </template>

        <template #serviceOperationCompany="{ slotProps }">
          <a-tooltip v-if="slotProps.text" :title="slotProps.text.name">{{ slotProps.text.name }}</a-tooltip>
          <span v-else>-</span>
        </template>

        <template #operation="{ slotProps }">
          <edit-button v-permission="{ action: 'base.inventory.update', effect: 'disabled' }"
            @click="$refs.inputDrawer.show(slotProps.record.id)"></edit-button>
          <delete-button v-permission="{ action: 'base.inventory.delete', effect: 'disabled' }"
            @confirm="confirm(slotProps.record.id)"></delete-button>
        </template>
      </list-layout>
    </a-card>

    <input-drawer ref="inputDrawer" @ok="confirm"></input-drawer>
    <upload-modal ref="uploadModal" @confirm="uploadConfirm"></upload-modal>
  </div>
</template>

<script>
import {
  getHostInventoryList,
  deleteHostInventory,
  exportHostInventory
} from '@/api/inventory.js'
import ListLayout from '@/components/ListLayout.vue'
import CreateButton from '@/components/button/CreateButton.vue'
import InputDrawer from './modules/InputDrawer.vue'
import UploadButton from '@/components/button/UploadButton.vue'
import UploadModal from './modules/UploadModal.vue'
import DeleteButton from '@/components/button/DeleteButton'
import EditButton from '@/components/button/EditButton'

export default {
  name: 'HostInventory',
  components: {
    ListLayout,
    CreateButton,
    InputDrawer,
    UploadButton,
    UploadModal,
    DeleteButton,
    EditButton
  },
  data() {
    return {
      getTableDataFunc: getHostInventoryList,
      exportFunc: exportHostInventory,
      refresh: false,
      columnsAll: [
        {
          dataIndex: 'vendor',
          title: '云服务商',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'vendor'
          }
        },
        {
          dataIndex: 'location',
          title: '云主机区域',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'location'
          }
        },
        {
          dataIndex: 'service',
          title: '业务系统名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'service'
          }
        },
        {
          dataIndex: 'added_service',
          title: '当前业务系统名称',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'addedService'
          }
        },
        {
          dataIndex: 'is_monitor_status',
          title: '是否监控',
          width: 110,
          scopedSlots: {
            customRender: 'isMonitorStatus'
          },
          filters: [
            {
              text: '是',
              value: 'true'
            },
            {
              text: '否',
              value: 'false'
            }
          ],
          filterMultiple: false
        },
        {
          dataIndex: 'architecture',
          title: '服务器架构',
          width: 140,
          scopedSlots: {
            customRender: 'architecture'
          }
        },

        {
          dataIndex: 'cpu',
          title: 'CPU (核)',
          width: 140,
          scopedSlots: {
            customRender: 'cpu'
          }
        },
        {
          dataIndex: 'memory',
          title: '内存 (G)',
          width: 140,
          scopedSlots: {
            customRender: 'memory'
          }
        },
        {
          dataIndex: 'disk',
          title: '普通存储 (G)',
          width: 140,
          scopedSlots: {
            customRender: 'disk'
          }
        },
        {
          dataIndex: 'ssd',
          title: 'SSD存储 (G)',
          width: 140,
          scopedSlots: {
            customRender: 'ssd'
          }
        },
        {
          dataIndex: 'storage_used',
          title: '存储使用',
          width: 160,
          scopedSlots: {
            customRender: 'storageUsed'
          }
        },
        {
          dataIndex: 'bandwidth',
          title: '带宽 (M)',
          width: 140,
          scopedSlots: {
            customRender: 'bandwidth'
          }
        },
        {
          dataIndex: 'name',
          title: '主机名',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'name'
          }
        },
        {
          dataIndex: 'private_ip',
          title: '云主机内网 IPV4',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'privateIp'
          }
        },
        {
          dataIndex: 'internal_ipv6',
          title: '云主机内网 IPV6',
          width: 200,
          scopedSlots: {
            customRender: 'internal_ipv6'
          }
        },
        {
          dataIndex: 'nat_ip',
          title: '一次NAT转换地址',
          width: 150,
          scopedSlots: {
            customRender: 'nat_ip'
          }
        },


        {
          dataIndex: 'multi_ip',
          title: '冗余IP',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'multiIp'
          }
        },
        {
          dataIndex: 'os',
          title: '操作系统',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'os'
          }
        },
        {
          dataIndex: 'port_maps',
          title: '端口映射',
          width: 220,
          scopedSlots: {
            customRender: 'portMaps'
          }
        },
        {
          dataIndex: 'applicant',
          title: '资源申请人',
          width: 130,
          ellipsis: true,
          scopedSlots: {
            customRender: 'applicant'
          }
        },
        {
          dataIndex: 'applicant_phone',
          title: '资源申请人联系电话',
          width: 180,
          ellipsis: true,
          scopedSlots: {
            customRender: 'applicantPhone'
          }
        },
        {
          dataIndex: 'allocated_at',
          title: '资源下发时间',
          width: 170,
          scopedSlots: {
            customRender: 'allocatedAt'
          }
        },
        {
          dataIndex: 'service.department',
          title: '系统管理部门',
          width: 170,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceDepartment'
          }
        },
        {
          dataIndex: 'service.built_at',
          title: '建设时间',
          width: 160,
          scopedSlots: {
            customRender: 'serviceBuiltAt'
          }
        },
        {
          dataIndex: 'service.launched_at',
          title: '上线时间',
          width: 160,
          scopedSlots: {
            customRender: 'serviceLaunchedAt'
          }
        },
        {
          dataIndex: 'service.project_manager',
          title: '系统负责人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceProjectManager'
          }
        },
        {
          dataIndex: 'service.project_manager_phone',
          title: '系统负责人联系电话',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceProjectManagerPhone'
          }
        },
        {
          dataIndex: 'service.operation_company',
          title: '运维公司',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceOperationCompany'
          }
        },
        {
          dataIndex: 'service.operation_company.manager',
          title: '运维负责人',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceOperationCompanyManager'
          }
        },
        {
          dataIndex: 'service.operation_company.phone_number',
          title: '运维负责人联系电话',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceOperationCompanyManagerPhone'
          }
        },
        {
          dataIndex: 'service.last_level',
          title: '等保级别',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceLastLevel'
          }
        },
        {
          dataIndex: 'service.project',
          title: '项目名称',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceProject'
          }
        },
        {
          dataIndex: 'service.signed_at',
          title: '项目合同签订日期',
          width: 160,
          scopedSlots: {
            customRender: 'serviceSignedAt'
          }
        },
        {
          dataIndex: 'service.last_evaluated_at',
          title: '最近一次等保测评完成时间',
          width: 200,
          scopedSlots: {
            customRender: 'serviceLastEvaluatedAt'
          }
        },
        {
          dataIndex: 'service.evaluate_company',
          title: '测评公司',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceEvaluateCompany'
          }
        },
        {
          dataIndex: 'service.evaluate_manager',
          title: '测评负责人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceEvaluateManager'
          }
        },
        {
          dataIndex: 'service.evaluate_manager_phone',
          title: '测评负责人联系电话',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceEvaluateManagerPhone'
          }
        },
        {
          dataIndex: 'service.last_tested_at',
          title: '最近一次软测时间',
          width: 160,
          scopedSlots: {
            customRender: 'serviceLastTestedAt'
          }
        },
        {
          dataIndex: 'service.test_company',
          title: '软件测评公司',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceTestCompany'
          }
        },
        {
          dataIndex: 'service.test_manager',
          title: '软测负责人',
          width: 140,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceTestManager'
          }
        },
        {
          dataIndex: 'service.test_manager_phone',
          title: '软测负责人联系电话',
          width: 160,
          scopedSlots: {
            customRender: 'serviceTestManagerPhone'
          }
        },
        {
          dataIndex: 'service.record_number',
          title: '备案证号码',
          width: 160,
          ellipsis: true,
          scopedSlots: {
            customRender: 'serviceRecordNumber'
          }
        },
        {
          dataIndex: 'service.recorded_at',
          title: '备案时间',
          width: 160,
          scopedSlots: {
            customRender: 'serviceRecordedAt'
          }
        },
        {
          dataIndex: 'comment',
          title: '备注',
          width: 170,
          ellipsis: true,
          scopedSlots: {
            customRender: 'comment'
          }
        }
      ],

      columnDefaultSelected: [
        'vendor',
        'location',
        'architecture',

        'cpu',
        'memory',
        'disk',
        'ssd',
        'storage_used',
        'bandwidth',
        'name',
        'private_ip',
        'internal_ipv6',
        'nat_ip',
        'is_monitor_status',
        // 'multi_ip',
        'os',
        'service',
        'added_service',
        'comment'
      ]
    }
  },
  methods: {
    getLevelColor(c) {
      if (c === 2) return '#ffbc75'
      if (c === 3) return '#ffab53'
      if (c === 4) return '#ff9a30'
      if (c === 5) return '#ff890e'
      return '#ffcc98'
    },
    async confirm(id = '') {
      if (id) {
        await deleteHostInventory(id).then(res => {
          this.$message.success(res.message)
        })
      }
      this.refresh = !this.refresh
    },
    uploadConfirm() {
      this.refresh = !this.refresh
    }
  }
}
</script>
